module.exports = "<ptooltip *ngIf=\"showTooltip\" [tooltip]=\"title\" [position]=\"'w'\">\n    <iicon [icon]=\"icon\"></iicon>\n</ptooltip>\n\n<iicon *ngIf=\"!showTooltip\" [icon]=\"icon\"></iicon>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-icon-button/paper-icon-button.component.html
// module id = ./src/app/components/polymer/paper-icon-button/paper-icon-button.component.html
// module chunks = main